export default function (quantity: number | undefined, singular: string, plural: string): string {
  if (!quantity && quantity !== 0) {
    return "";
  }
  return quantity > 1 || quantity === 0
    ? plural
    : singular;
}